export default __webpack_public_path__ + "static/media/Chainlink-Symbol.570ef019.svg";